import React from 'react';
//import { useState } from 'react';
import { Modal } from '@mantine/core';
import PrimaryButton from 'components/primaryButton';
import SecondaryButton from 'components/secondaryButton';
import chat from '../../../assets/images/chat.svg';
import { useWindowSize } from 'react-use';
import useUpdateMailStatus from '../hooks/useUpdateMailStatus';

import { ReactComponent as CrossIcon } from 'assets/icons/crossIcon.svg';

const Deletechat = (props) => {
  const useupdateMailStatus = useUpdateMailStatus();
  const width = useWindowSize();
  const { isModalOpen, setIsModalOpen } = props;

  const closeModal = () => {
    setIsModalOpen(false);
  };

  //model size
  function modelsize() {
    if (width >= 1280 && width <= 1535) {
      return 'lg';
    } else if (width >= 1536) {
      return 'xl';
    } else {
      return 'lg';
    }
  }
  const size1 = modelsize();

  return (
    <>
      <Modal
        opened={isModalOpen}
        onClose={() => closeModal()}
        size={size1}
        centered
        withCloseButton={false}
        transitionDuration={100}
        overlayBlur={20}
        overlayOpacity={0.5}
        overlayColor={'#F8F7F799'}
        overflow='inside'
        className='rounded-[13px]'
        classNames={{
          body: 'scroller h-auto',
          modal: 'p-10 rounded-[13px]',
        }}
      >
        <CrossIcon
          className='w-14 ml-auto cursor-pointer'
          onClick={() => closeModal(false)}
        />
        <div className='flex flex-col justify-center items-center gap-y-12'>
          <h1 className='text-xl text-neutralsBlack text-center 2xl:text-2xl'>
            Do you want to permanently delete the selected
            <span className='text-4xl'> conversation?</span>
          </h1>
          <img src={chat} alt='chat' />
          <div className='flex gap-x-6 justify-center items-center'>
            <button
              className='w-24 2xl:w-28 3xl:w-32'
              onClick={() => {
                useupdateMailStatus.mutate({
                  id: props.id,
                  permanently_delete: true,
                });
                closeModal();
              }}
            >
              <SecondaryButton>Yes</SecondaryButton>
            </button>
            <button
              className='w-24 2xl:w-28 3xl:w-32'
              onClick={() => closeModal()}
            >
              <PrimaryButton>No</PrimaryButton>
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Deletechat;
